import { LoadingOutlined, MailOutlined } from "@ant-design/icons";
import { notification } from "antd";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  authResetPassword,
  sampleApiCall,
} from "../../../apiservice/authService";
import { IAuthType } from "../../../apiservice/authService.type";
import useFormatApiRequest from "../../../hooks/formatApiRequest";
import { useAppDispatch } from "../../../Redux/reduxCustomHook";
import { NotificationType } from "../../../utils/mscType.type";
import "../userAuth.css";
import UserAuthHeader from "../userAuthHeader";

const UserForgetPassword = () => {
  const [formLoading, setFormLoading] = useState<boolean>(false);
  const [loadApi, setLoadApi] = useState(false);
  const [user, setUser] = useState<any>({});
  const [api, contextHolder] = notification.useNotification();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  // Use to collect Site Description Change
  const handleInputChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setUser((values: any) => ({ ...values, [name]: value }));
  };

  // Use to Submit Form
  const handleSubmit = (event: any) => {
    event.preventDefault();
    setLoadApi(true);
    setFormLoading(true);
  };

  // A custom hook to format the login Api
  const result = useFormatApiRequest(
    () => authResetPassword(user),
    loadApi,
    () => {
      setLoadApi(false);
    },
    () => {
      processApi();
    }
  );

  // Process Api
  const processApi = async () => {
    if (result.httpState === "SUCCESS") {
      setFormLoading(false);
      const signinResult: IAuthType = result.data;
      // storePlainString(USER_TOKEN_KEY, signinResult?.data?.token || "");
      // storeJSON(USER_AUTH_DATA_KEY, signinResult);
      // dispatch({ type: "AUTH_ADD_DATA", payload: signinResult });

      setTimeout(() => {
        navigate("/auth/user-setnew-password?email=" + user?.email);
      }, 1500);
      openNotificationWithIcon(
        "info",
        "",
        "We will email you password reset Instructions",
        "#D9FFB5"
      );

      // Handle Success Here
    } else if (result.httpState === "ERROR") {
      setFormLoading(false);
      //Handle Error Here
      openNotificationWithIcon(
        "info",
        "",
        result.data?.response?.data?.errors?.[0].message ||
          result.data?.response?.data?.message ||
          result.errorMsg ||
          "Login Error",
        "#FFC2B7"
      );
    }
  };

  // Show Notification
  const openNotificationWithIcon = (
    type: NotificationType,
    message: string,
    description: string,
    background?: string
  ) => {
    api[type]({
      message,
      description,
      placement: "bottomRight",
      style: { background },
    });
  };

  return (
    <>
      {contextHolder}

      {/* Main Background */}
      <div className="flex flex-col min-h-screen bg-white dark:bg-stone-900">
        {/* Logo Section */}
        <div className="w-full flex flex-col items-center">
          <div className="p-4 pt-12 pb-12">
            <img
              src={`${process.env.PUBLIC_URL + "/images/logobluebig.svg"}`}
              alt="Logo"
              className="w-32 h-auto"
            />
            <br />

            {/* <img
              src={`${process.env.PUBLIC_URL + "/images/logoblue.svg"}`}
              alt="Logo"
              className="w-32 h-auto"
            /> */}
          </div>

          <div className="p-4 w-full rounded-t-3xl">
            <p className="font-semibold fontKanitRegular text-xl text-center text-blue-800 dark:text-blue-400">
              Forget Password
            </p>
            <p className="text-center text-blue-800 dark:text-blue-400">
              {" "}
              No worries, we’ll send you reset instructions
            </p>
          </div>
        </div>

        {/* Form Area */}
        <div className="flex justify-center items-center p-4">
          <div className="w-full max-w-lg p-8 rounded-xl bg-white dark:bg-stone-800 shadow-lg">
            {" "}
            {/* Added bg and shadow */}
            <form onSubmit={handleSubmit}>
              {/* Email Address */}
              <div className="relative w-full mb-6">
                <label className="absolute -top-3 left-3 bg-white dark:bg-stone-800 px-1 text-blue-800 dark:text-blue-400 text-sm">
                  Email Address
                </label>
                <input
                  required
                  name="email"
                  value={user?.email}
                  onChange={handleInputChange}
                  type="email"
                  className="pl-10 pr-4 py-2 border dark:border-stone-600 rounded-lg w-full h-16 bg-transparent text-blue-800 dark:text-sky-300 placeholder-gray-500 dark:placeholder-stone-400"
                  placeholder="Enter your email"
                />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <MailOutlined className="text-blue-800 dark:text-blue-400" />
                </div>
              </div>

              {/* Login Button */}
              <div className="mb-2">
                <button className="w-full h-16 fontAlbertSansRegular text-white bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 rounded-xl text-lg">
                  {!formLoading ? (
                    "Reset Password"
                  ) : (
                    <LoadingOutlined rev={undefined} />
                  )}
                </button>
              </div>
            </form>
            {/* Don’t have an account yet? Sign up */}
            <div className="mt-4 text-center text-blue-800 dark:text-blue-400">
              <p>
                Go Back to{" "}
                <Link to={"/auth"}>
                  <span className="underline text-blue-800 dark:text-blue-400">
                    Login Page
                  </span>
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserForgetPassword;
